import { SidePanelDS, Spacer, RemoveRedEyeOutlined, Tag } from "@qivia/ui";
import { LittleCardAsset } from "@qivia/ui/src/assets/assets";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { PublicEmspCdrs } from "../../transactionsAPI";

export const SidePanelSectionBlock = (props: {
  cdr: PublicEmspCdrs;
  firstPath: string;
}) => {
  const navigate = useNavigate();

  return (
    <SidePanelDS.ActionBlock>
      <SidePanelDS.SectionedActionStripe
        left={
          <StyledRow>
            <LittleCardAsset />
            <Spacer x={1} />
            {`**** ${props.cdr.last4Digits.toString()}`}
          </StyledRow>
        }
        right={
          <StyledLittleIcon>
            <RemoveRedEyeOutlined
              key="card"
              onClick={() =>
                navigate(
                  `/${props.firstPath}/cards/cards/${props.cdr.cardUuid}?fromNavigate=true`,
                )
              }
            />
            <Spacer x={1} />
          </StyledLittleIcon>
        }
      />
      <SidePanelDS.SectionedActionStripe
        left={
          <StyledRowCenter>
            {props.cdr.registrationNumber}
            {props.cdr.vehicleReference && (
              <>
                <Spacer x={1} />
                <Tag
                  textColor={colors["colors/text/darkGrey"]}
                  text={props.cdr.vehicleReference}
                  backgroundColor={
                    colors["colors/surfaces/background/background_level0"]
                  }
                  borderColor={colors["colors/text/darkGrey"]}
                />
              </>
            )}
          </StyledRowCenter>
        }
        right={
          <StyledLittleIcon>
            <RemoveRedEyeOutlined
              key="vehicle"
              onClick={() =>
                navigate(
                  `/${props.firstPath}/vehicles/${props.cdr.vehicleUuid}?fromNavigate=true`,
                )
              }
            />
            <Spacer x={1} />
          </StyledLittleIcon>
        }
      />
    </SidePanelDS.ActionBlock>
  );
};

const StyledRow = styled.div`
  display: flex;
  align-items: flex-end;
`;

const StyledRowCenter = styled.div`
  ${typographies["Body/S"]}
  display: flex;
  align-items: center;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;
const StyledLittleIcon = styled.div`
  display: flex;
  cursor: pointer;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;
